import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { FetchedFolder } from "@/services/api/fetchers/folders";
import { DrawerAndModal } from "@/shared/components/common/DrawerAndModal";
import { ConfirmDeleteFolderContent } from "./ConfirmDeleteFolderContent";

interface ConfirmDeleteFolderProps {
  id: string;
  isBulkDelete: boolean;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  folder?: FetchedFolder | null;
  folderCount?: number;
  noteCount?: number;
  onConfirm: () => void;
}

export function ConfirmDeleteFolder({
  id,
  folder,
  folderCount = 0,
  noteCount = 0,
  isOpen,
  isBulkDelete,
  onConfirm,
  onOpenChange,
}: ConfirmDeleteFolderProps) {
  const { deviceType } = useBoundStore(useShallow((state) => ({ deviceType: state.device.type })));
  const title = isBulkDelete ? "Delete Items" : "Delete Folder";

  return (
    <DrawerAndModal
      closeLabel="Cancel"
      confirmLabel="Delete"
      id={id}
      title={title}
      externalState={{ isOpen, onOpenChange }}
      onConfirm={onConfirm}
    >
      <ConfirmDeleteFolderContent
        isBulkDelete={isBulkDelete}
        folder={folder}
        folderCount={folderCount}
        noteCount={noteCount}
        onConfirm={onConfirm}
        onOpenChange={onOpenChange}
        deviceType={deviceType}
      />
    </DrawerAndModal>
  );
}
